import { render } from "./proposal-loading.vue?vue&type=template&id=ee4a32c2&scoped=true"
import script from "./proposal-loading.vue?vue&type=script&lang=js"
export * from "./proposal-loading.vue?vue&type=script&lang=js"

import "./proposal-loading.vue?vue&type=style&index=0&id=ee4a32c2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4a32c2"]])

export default __exports__